import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.trim.js";
import { trimHtml } from '@applyboard/ui-utils';

/**
 * Truncates an HTML string based on the length of the visible characters.
 * Trims string before truncation
 *
 * @param str The HTML string to truncate
 * @param count How many characters to include in the truncation
 * @returns The truncated html substring
 * @note Modified version of function found here: https://stackoverflow.com/a/6003713
 */
export function htmlSubstr(str, count) {
  if (typeof count !== 'number') {
    return {
      result: str,
      truncated: false
    };
  }
  var truncated = false;
  var div = document.createElement('div');
  div.innerHTML = trimHtml(str);
  walk(div, track);
  function track(el) {
    if (typeof count === 'number' && count > 0) {
      var len = el.data.length;
      count -= len;
      if (count <= 0) {
        el.data = el.substringData(0, el.data.length + count);
        truncated = true;
      }
    } else {
      el.data = '';
    }
  }
  function walk(el, fn) {
    var node = el.firstChild;
    if (!node) {
      return;
    }
    do {
      if (isText(node)) {
        fn(node);
      } else if (node.nodeType === 1 && node.childNodes && node.childNodes[0]) {
        walk(node, fn);
      }
    } while (node = node.nextSibling);
  }
  return {
    result: trimHtml(div.innerHTML),
    truncated: truncated
  };
}
function isText(node) {
  return node.nodeType === 3;
}
export function appendInlineHtml(html, inlineHtml) {
  var div = document.createElement('div');
  div.innerHTML = html;
  var lastChild = div;
  while (lastChild.lastElementChild && lastChild.lastElementChild === lastChild.lastChild && !isEmptyList(lastChild.lastElementChild) && !['A', 'BUTTON'].includes(lastChild.lastElementChild.tagName)) {
    lastChild = lastChild.lastElementChild;
  }
  var span = document.createElement('span');
  span.innerHTML = inlineHtml;
  var validTags = ['SPAN', 'DIV', 'P', 'LI', 'B', 'STRONG'];
  if (span.lastElementChild) {
    if (validTags.includes(lastChild.tagName)) {
      lastChild.appendChild(span.lastElementChild);
    } else {
      div.appendChild(span.lastElementChild);
    }
  }
  return div.innerHTML;
}
function isEmptyList(el) {
  return (el.tagName === 'UL' || el.tagName === 'OL') && el.innerHTML.trim() === '';
}